'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sair = exports.inserirAnuncio = exports.chat = exports.meusAnuncios = exports.busca = exports.getUrls = exports.comprasOLXPay = exports.vendasOLXPay = exports.olxPay = exports.centralDeSeguranca = exports.gerenciarComunicacoes = exports.venderNaOLX = exports.planoProfissional = exports.minhaConta = exports.politicaDeProtecaoAPropriedade = exports.politicaDePrivacidade = exports.gerenciarPagamentos = exports.favoritos = exports.meuPlano = exports.login = exports.copyRight = exports.dicasDeSeguranca = exports.deleteAccount = exports.confirmarTelefone = exports.trocaSenha = exports.sobreOlx = exports.notificacoes = exports.ajuda = exports.home = exports.faleConosco = exports.esqueciMinhaSenha = exports.termosDeUso = undefined;
var _isMobile = require('../util/isMobile');
var _isMobile2 = _interopRequireDefault(_isMobile);
var _mobileUrls = require('./mobileUrls');
var mobileUrls = _interopRequireWildcard(_mobileUrls);
var _desktopUrls = require('./desktopUrls');
var desktopUrls = _interopRequireWildcard(_desktopUrls);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var urls = (0, _isMobile2.default)() ? mobileUrls : desktopUrls;
var termosDeUso = exports.termosDeUso = 'https://ajuda.olx.com.br/s/article/termos-e-condicoes-de-uso';
var esqueciMinhaSenha = exports.esqueciMinhaSenha = 'https://conta.olx.com.br/recuperacao-senha';
var faleConosco = exports.faleConosco = 'https://ajuda.olx.com.br';
var home = exports.home = 'https://www.olx.com.br/';
var ajuda = exports.ajuda = 'https://www.olx.com.br/faq.htm';
var notificacoes = exports.notificacoes = 'https://conta.olx.com.br/notificacoes/';
var sobreOlx = exports.sobreOlx = 'https://portal.olx.com.br/';
var trocaSenha = exports.trocaSenha = 'https://conta.olx.com.br/nova-senha';
var confirmarTelefone = exports.confirmarTelefone = 'https://conta.olx.com.br/confirmacao-telefone/';
var deleteAccount = exports.deleteAccount = 'https://atendimento.olx.com.br/contas/inativacao';
var dicasDeSeguranca = exports.dicasDeSeguranca = 'https://www.olx.com.br/seguranca';
var copyRight = exports.copyRight = 'https://www.olx.com.br/copyright.htm';
var login = exports.login = 'https://www3.olx.com.br/account/form_login';
var meuPlano = exports.meuPlano = 'https://planoprofissional.olx.com.br';
var favoritos = exports.favoritos = 'https://www3.olx.com.br/account/favorites';
var gerenciarPagamentos = exports.gerenciarPagamentos = 'https://conta.olx.com.br/pagamentos';
var politicaDePrivacidade = exports.politicaDePrivacidade = 'https://ajuda.olx.com.br/s/article/politica-de-privacidade';
var politicaDeProtecaoAPropriedade = exports.politicaDeProtecaoAPropriedade = 'https://ajuda.olx.com.br/s/article/protecao-a-propriedade';
var minhaConta = exports.minhaConta = 'https://www3.olx.com.br/account/form_userinfo';
var planoProfissional = exports.planoProfissional = 'https://www.olx.com.br/planos';
var venderNaOLX = exports.venderNaOLX = 'https://www.olx.com.br/vender';
var gerenciarComunicacoes = exports.gerenciarComunicacoes = 'https://conta.olx.com.br/comunicacoes';
var centralDeSeguranca = exports.centralDeSeguranca = 'https://conta.olx.com.br/seguranca';
var olxPay = exports.olxPay = 'https://wallet.olx.com.br';
var vendasOLXPay = exports.vendasOLXPay = 'https://meus-pedidos.olx.com.br/vendas';
var comprasOLXPay = exports.comprasOLXPay = 'https://meus-pedidos.olx.com.br/compras';
function getUrlByPlatform(link) {
  return (0, _isMobile2.default)() ? mobileUrls[link] : desktopUrls[link];
}
var getUrls = exports.getUrls = function getUrls() {
  return {
    home: getUrlByPlatform('home'),
    busca: getUrlByPlatform('busca'),
    meusAnuncios: getUrlByPlatform('meusAnuncios'),
    chat: getUrlByPlatform('chat'),
    inserirAnuncio: getUrlByPlatform('inserirAnuncio')
  };
};
var busca = urls.busca,
  meusAnuncios = urls.meusAnuncios,
  chat = urls.chat,
  inserirAnuncio = urls.inserirAnuncio,
  sair = urls.sair;
exports.busca = busca;
exports.meusAnuncios = meusAnuncios;
exports.chat = chat;
exports.inserirAnuncio = inserirAnuncio;
exports.sair = sair;